import React from 'react';
import BModal from 'react-bootstrap/Modal';
import omit from 'lodash/omit';

const Modal = (props) => {
  const { onHide, children, className } = props;

  return (
    <BModal
      centered
      {...omit(props, ['children', 'className'])}
    >
      <div
        className="btn-close"
        onClick={onHide}
      ></div>
      <BModal.Body className={className}>
        {children}
      </BModal.Body>
    </BModal>
  );
};

export default Modal;
